import DialogDefault from './DialogDefault';

export default DialogDefault;
